import { render, staticRenderFns } from "./AntiplateletList.vue?vue&type=template&id=63e41283"
import script from "./AntiplateletList.vue?vue&type=script&lang=js"
export * from "./AntiplateletList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports